import { useState } from "react";
import { useApi } from "providers/ApiProvider";
import { CertificateDisplayType } from "type/certificateType";
import { getCertificateStatus } from "utils/certificateUtil";

type DisplayStatusType = CertificateDisplayType | null | "SELECT_DOCTOR";

export const useCertificateDisplay = () => {
  const [displayStatus, setDisplayStatus] = useState<DisplayStatusType>(null);
  const { certificateApi } = useApi();

  const getCertificate = async () => {
    const response = await certificateApi.getCertificateConfig();
    const certificateConfig = response.data;
    return certificateConfig.data?.externalCertificateId
      ? certificateConfig.data
      : null;
  };

  const initialize = async (certificate: any, hasCertificateList: any[]) => {
    //병원내 인증서 등록 계정(=의사계정이라고 칭함) 유무 : users/duty로 조회후 인증서 등록 필터링
    const hasDoctorCertificate = hasCertificateList.length > 0;
    const hasCertificate = certificate?.externalCertificateId ? true : false; //전자서명을 가지고 있으면 "의사계정" 이라고 칭함
    if (
      hasCertificate &&
      certificate !== null &&
      (getCertificateStatus(certificate.endDate) === "EXPIRE" ||
        getCertificateStatus(certificate.endDate) === "GRACE_PERIOD")
    ) {
      // 의사계정&인증서등록&인증서만료상태 : 전자서명 인증서 만료
      return setDisplayStatus("EXPIRE");
    }

    if (
      hasCertificate &&
      certificate !== null &&
      certificate.certType === "AUTO"
    ) {
      // 의사계정&인증서등록&자동전자서명옵션 AUTO : 자동 전자서명
      return setDisplayStatus("AUTO");
    }

    if (
      hasCertificate &&
      certificate !== null &&
      certificate.certType === "MANUAL"
    ) {
      // 의사계정&인증서등록&자동전자서명옵션 MANUAL : 수동 전자서명
      return setDisplayStatus("MANUAL");
    }

    if (
      (hasCertificate && certificate === null) ||
      (!hasCertificate && !hasDoctorCertificate)
    ) {
      // 의사계정&인증서미등록 : 전자서명 미사용
      // 의사외계정&인증서등록의사계정없음 : 전자서명 미사용
      return setDisplayStatus("NOT_USED");
    }

    if (!hasCertificate && hasDoctorCertificate) {
      // 의사외계정&병원에인증서등록된의사계정있음 : 전자서명요청
      return setDisplayStatus("SELECT_DOCTOR");
    }
  };

  return { initialize, displayStatus, getCertificate };
};
